"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../helpers/index.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var stringField = _index.formatters.stringField,
  numberField = _index.formatters.numberField,
  listField = _index.formatters.listField;
var getCheckoutViewsTemplate = function getCheckoutViewsTemplate(_ref) {
  var cartID = _ref.cartID,
    cartSource = _ref.cartSource,
    checkoutSteps = _ref.checkoutSteps,
    _ref$isCheckoutStart = _ref.isCheckoutStart,
    isCheckoutStart = _ref$isCheckoutStart === void 0 ? false : _ref$isCheckoutStart,
    numberOfAccessories = _ref.numberOfAccessories,
    numberOfPhones = _ref.numberOfPhones,
    numberOfTablets = _ref.numberOfTablets,
    numberOfWatches = _ref.numberOfWatches;
  var checkoutStartFields = isCheckoutStart ? {
    value: 1
  } : {};
  return {
    cart: {
      cartID: cartID,
      cartSource: stringField(cartSource)
    },
    checkouts: _objectSpread(_objectSpread({}, checkoutStartFields), {}, {
      _telus: {
        checkoutSteps: listField(checkoutSteps, {
          separator: '|'
        })
      }
    }),
    _telus: {
      numberOfAccessories: numberField(numberOfAccessories),
      numberOfPhones: numberField(numberOfPhones),
      numberOfTablets: numberField(numberOfTablets),
      numberOfWatches: numberField(numberOfWatches)
    }
  };
};
var _default = exports["default"] = getCheckoutViewsTemplate;